import React, { Component } from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import { FormattedMessage } from "react-intl";
import "./FAQWrapper.scss";
class FAQWrapper extends Component {
  renderPanel = (id, titleId, bodyContent) => {
    return (
      <div className="panel">
        <div className="panel-heading">
          <h4
            className="panel-title"
            data-toggle="collapse"
            aria-expanded="false"
            data-target={`#${id}`}
            aria-controls={id}
            style={{ cursor: "pointer" }}
          >
            <FormattedMessage id={titleId} />
          </h4>
        </div>
        <div
          id={id}
          className="panel-collapse collapse"
          aria-labelledby={id}
          data-parent="#accordion-1"
        >
          <div className="panel-body">{bodyContent}</div>
        </div>
        <div className="half-border" />
      </div>
    );
  };

  render() {
    return (
      <section id="faq" className="faq">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <div className="panel-group accordion" id="accordion-1">
                {this.renderPanel(
                  "one",
                  "faq.a1",
                  <>
                    <p>
                      <FormattedMessage id="faq.a1_1" />
                    </p>
                    <p>
                      <FormattedMessage id="faq.a1_2" />
                    </p>
                    <p>
                      <FormattedMessage id="faq.a1_3" />
                    </p>
                    <p>
                      <FormattedMessage id="faq.a1_4" />
                    </p>
                    <p>
                      <FormattedMessage id="faq.a1_5" />
                    </p>
                    <p>
                      <FormattedMessage id="faq.a1_6" />
                    </p>
                  </>
                )}

                {/* {this.renderPanel(
                  "two",
                  "faq.a3",
                  <p>
                    <FormattedMessage id="faq.a4" />
                  </p>
                )} */}

                {this.renderPanel(
                  "three",
                  "faq.a5",
                  <p>
                    <FormattedMessage id="faq.a6" />
                    <br />
                    <FormattedMessage id="faq.a7" />
                  </p>
                )}

                {/* {this.renderPanel(
                  "four",
                  "faq.a8",
                  <p>
                    <FormattedMessage id="faq.a9" />
                  </p>
                )} */}

                {this.renderPanel(
                  "four2",
                  "faq.a10",
                  <p>
                    <FormattedMessage id="faq.a11" />
                  </p>
                )}

                {this.renderPanel(
                  "five",
                  "faq.a12",
                  <p>
                    <FormattedMessage id="faq.a13" />
                    <br /> <FormattedMessage id="faq.a14" />
                    <br /> <FormattedMessage id="faq.a15" />
                  </p>
                )}

                {this.renderPanel(
                  "six",
                  "faq.a16",
                  <p>
                    <FormattedMessage id="faq.a17" />
                    <br /> <br />
                    <FormattedMessage id="faq.a18" />
                    <br /> <br />
                    <FormattedMessage id="faq.a19" />
                  </p>
                )}

                {this.renderPanel(
                  "seven",
                  "faq.a20",
                  <p>
                    <FormattedMessage id="faq.a21" />
                    <br /> <FormattedMessage id="faq.a22" />
                    <br /> <FormattedMessage id="faq.a23" />
                  </p>
                )}

                {this.renderPanel(
                  "eight",
                  "faq.a24",
                  <p>
                    <FormattedMessage id="faq.a25" />
                    <br /> <br />
                    <span style={{ fontWeight: 600 }}>
                      <FormattedMessage id="faq.a26" />
                    </span>
                    <FormattedMessage id="faq.a27" />
                    <br /> <br />
                    <span style={{ fontWeight: 600 }}>
                      <FormattedMessage id="faq.a28" />
                    </span>
                    <FormattedMessage id="faq.a29" />
                    <br /> <br />
                    <span style={{ fontWeight: 600 }}>
                      <FormattedMessage id="faq.a30" />
                    </span>
                    <FormattedMessage id="faq.a31" />
                  </p>
                )}

                {this.renderPanel(
                  "nine",
                  "faq.a32",
                  <p>
                    <FormattedMessage id="faq.a33" />
                    <br /> <br />
                    <span style={{ fontWeight: 600 }}>
                      <FormattedMessage id="faq.a34" />
                    </span>
                    <FormattedMessage id="faq.a35" />
                    <br /> <br />
                    <span style={{ fontWeight: 600 }}>
                      <FormattedMessage id="faq.a36" />
                    </span>
                    <FormattedMessage id="faq.a37" />
                    <br /> <br />
                    <span style={{ fontWeight: 600 }}>
                      <FormattedMessage id="faq.a38" />
                    </span>
                    <FormattedMessage id="faq.a39" />
                    <br /> <br />
                    <span style={{ fontWeight: 600 }}>
                      <FormattedMessage id="faq.a40" />
                    </span>
                    <FormattedMessage id="faq.a41" />
                  </p>
                )}
              </div>
            </div>
          </div>
        </div>
      </section>
    );
  }
}

const mapStateToProps = (state) => ({});
const mapDispatchToProps = (dispatch) => ({});

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(FAQWrapper)
);
